module.exports = __webpack_public_path__ + "static/UnclickNo-4dc12cfc4896a1a8fe4cb6b18ce24886.png";